import { createFileRoute, Outlet, useMatches } from '@tanstack/react-router'
import { clientsSearchSchema } from '@/features/clients/model'
import { ClientsScreen } from '@/features/clients/routes/clients-screen'

export const Route = createFileRoute('/clients')({
  // The list's filters live in the address (src/features/clients/model.ts).
  validateSearch: clientsSearchSchema,
  component: ClientsLayout,
})

function ClientsLayout() {
  // A client's page owns the whole screen; the list shows when none is open.
  const matches = useMatches()
  const hasChild = matches.some((match) => match.routeId === '/clients/$clientId')
  const search = Route.useSearch()
  return hasChild ? <Outlet /> : <ClientsScreen search={search} />
}
